// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2RGtN","paramInput":"JobSimulator_paramInput__1ygZ6","input":"JobSimulator_input__2G6w-"};